import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./Components/LandingPage";
import Login from "./Components/Auth/Login";
import Dashboard from "./adminview/pages/Dashboard/Dashboard";
import About from "./adminview/pages/About/about";
import FoodProgram from "./adminview/pages/FoodProgram/foodprogram";
import Navbar from "./Components/Navbar";
import DisaterRef from "./adminview/pages/DisaterRef/disaterRef";
import FreeMedicine from "./adminview/pages/FreeMedicine/freemedicine";
import HealthCare from "./adminview/pages/HealthCare/healthcare";

function App() {
  //Paid Condition
  const value = 1;
  useEffect(() => {
    localStorage.setItem("paid", value);
  }, []);
  const paid = localStorage.getItem("paid");
  if (paid == 1) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          {/* Login Routes */}
          <Route path="/Login" element={<Login />} />
          {/* Admin View */}

          <Route path="/Dashboard" element={<Dashboard />} />

          <Route path="/about" element={<About />} />

          <Route path="/food-program" element={<FoodProgram />} />

          <Route path="/disater-ref" element={<DisaterRef />} />

          <Route path="/free-medicine" element={<FreeMedicine />} />

          <Route path="/health-care" element={<HealthCare />} />
        </Routes>
      </BrowserRouter>
    );
  } else {
    return (
      <h1 style={{ textAlign: "center", fontSize: "50px", marginTop: "10%" }}>
        Pay Pending Dues !
      </h1>
    );
  }
}

export default App;
